import { Check, X } from '../../components/ui/icons';
import { cn } from '../../lib/cn';
import { STATE_LABEL, type MarketState } from './helpers';

/** One market in a pick breakdown: hit/miss/on-track marker, label · selection, multiplier, state. */
export function MarketLine({
  label,
  value,
  state,
  factor
}: {
  label: string;
  value: string;
  state: MarketState;
  factor?: string;
}) {
  const good = state === 'hit' || state === 'ontrack';
  const bad = state === 'miss' || state === 'offtrack';
  return (
    <div className="flex items-center gap-[10px]">
      <span
        className={cn(
          'grid h-[18px] w-[18px] shrink-0 place-items-center rounded-full',
          state === 'hit' && 'bg-accent',
          state === 'miss' && 'bg-miss/20',
          state === 'ontrack' && 'border-2 border-accent',
          state === 'offtrack' && 'border-2 border-miss',
          state === 'open' && 'border-[1.5px] border-ink4'
        )}
      >
        {state === 'hit' && <Check width={11} height={11} strokeWidth={3.5} className="text-[#06371F]" />}
        {state === 'miss' && <X width={10} height={10} strokeWidth={3.4} className="text-danger" />}
        {state === 'ontrack' && <span className="h-[6px] w-[6px] rounded-full bg-accent" />}
      </span>
      <span className="flex-1 truncate text-[12.5px] font-semibold text-ink2">
        {label} · <span className="font-extrabold text-ink">{value}</span>
      </span>
      {factor && (
        <span
          className={cn(
            'num shrink-0 rounded-md px-[6px] py-[2px] text-[10.5px] font-extrabold',
            factor.startsWith('÷') ? 'bg-miss/10 text-miss' : 'bg-fill text-ink3'
          )}
        >
          {factor}
        </span>
      )}
      <span
        className={cn(
          'shrink-0 text-[11px] font-bold',
          good && 'text-accent-ink',
          bad && 'text-miss',
          state === 'open' && 'text-ink3'
        )}
      >
        {STATE_LABEL[state]}
      </span>
    </div>
  );
}
